import { render, staticRenderFns } from "./Good.vue?vue&type=template&id=4e77eace"
import script from "./Good.vue?vue&type=script&lang=js"
export * from "./Good.vue?vue&type=script&lang=js"
import style0 from "./Good.vue?vue&type=style&index=0&id=4e77eace&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports